import styled, { css } from 'styled-components';

const dragActive = css`
    border-color: #1c0506;
`

const dragReject = css`
    border-color: #c32027;
`

const haveImage = css`
    border-color: #1c0506;
    background-color: #faf8f8;
`

export const StyledTbody = styled.tbody`
    position: static;
    top: auto !important;
    left: auto !important;
    cursor: pointer;
    background-color: ${props => (props.isDragging ? '#faf8f8' : '#fff')};
    :hover {
            background-color: #faf8f8
        }
    tr {
        cursor: pointer;
    }
`

export const DropContainer = styled.div.attrs({
    className: "dropzone"
})`
    display: -webkit-box;
    -webkit-box-orient: vertical;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    outline: none;
    height: 9.5rem;
    width: 100%;
    max-width: 41.4375rem;
    border: 2px dashed #a09c9d;
    border-radius: 8px;
    cursor: pointer;

    transition: height 0.2s ease;

    ${props => props.haveImage && haveImage};
    ${props => props.isDragActive && dragActive};
    ${props => props.isDragReject && dragReject};

    font-family: Montserrat;
    font-stretch: normal;
    font-style: normal;
    line-height: 0.75;
    letter-spacing: normal;
    font-size: 16px;

    @media (max-width: 360px) {
        height: 11rem;
    }

    .icon-image {
        margin-bottom: 1rem;
    }

    .bold {
        font-weight: 600;
    }

    .nome {
        margin-bottom: 16px;
        font-weight: 700;
        width: 88%; 
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1; /* number of lines to show */
        -webkit-box-orient: vertical;
    }
`;

const messageColors = {
    default: '#2a0709',
    error: '#c32027',
    success: '#1c0506',
};

export const UploadMessage = styled.div`
    display: flex;
    flex-direction: column;
    color: ${props => messageColors[props.type || 'default']};
    justify-content: center;
    align-items: center;
`;

export const Container = styled.div`
    -webkit-filter: blur(0px);
    width: 100%;
    height: 100%;
    overflow: visible;
    display: flex;
    background-color: #fff;
    flex-direction: column;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;

    .td-empty {
        padding: 0;
        border: none;
    }

    .more-button {
            /* position: absolute;
            right: 6px;
            top: 6px; */
            cursor: pointer;
            height: 32px;
            width: 32px;
            outline: none;
            border: none;
            border-radius: 32px;
            background-color: transparent;
            justify-content: center;
            align-items: center;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 600;
            transition: 0.2s;
            padding: 0;
            padding-top: 4px;
            .icon {
            color: #a49b9b;
            width: 18px;
            height: 18px;
                align-self: center;
            }
            /* :hover {
                color: #9c1a1f
            } */
            :active {
                background-color: #dedede
                }           
                /* @media(max-width: 360px) {
                    width: 100%;
                } */
            }

                    table {
                        width: 100%;
                        margin: 0;
                        margin-top: 2rem;
                        margin-bottom: 6rem;
                        font-family: Montserrat;
                        text-align: left;
                        font-size: 16px;
                        border: none;
                        border-collapse: collapse;
                        /* margin-left: -32px;
                        padding-right: -64px; */

                        td {
                            max-width: 196px;
                            color: #2a0709;
                            padding: 24px 0;
                            padding-right: -32px;
                            border: none;
                            border-top: 2px solid #f3f3f3;

                            :first-child {
                                padding-left: 32px;
                            }

                            span {
                                color: #2a0709;
                            }

                            .switch {
                                width: 106px;
                                cursor: pointer;
                                display: flex;
                                flex-direction: row;
                                align-items: center;

                                h4 {
                                    margin: 0;
                                    margin-left: 16px;
                                    padding: 0;
                                    font-family: Montserrat;
                                    font-size: 16px;
                                    font-weight: 400;
                                    font-stretch: normal;
                                    font-style: normal;
                                    line-height: 1;
                                    letter-spacing: normal;
                                    text-align: left;
                                    color: #2a0709
                                }
                            }

                            .prodImg {
                                width: 48px;
                                height: 48px;
                                border-radius: 4px;
                                overflow: hidden;
                                object-fit: cover;
                            }
                        }

                        .th-drag {
                            width: 7.29%;
                        }

                        .th-nome {
                            width: 30.905%;
                            padding-left: 1rem
                        }

                        /* .th-img {
                            width: 11.13%
                        }


                        .th-descricao {
                            width: 20.80%;
                        }

                        .th-valor {
                            width: 11.95%;
                        }*/

                        .th-switch {
                            width: 30.90%;
                        } 

                        .td-drag {
                            width: 7.29%;
                            padding-left: 2rem !important;
                            
                            @media (max-width: 360px) {
                                padding-left: 1rem !important;
                            }

                            .icon {
                                color: #a49b9b;
                                width: 16px;
                                height: 16px;
                            }
                        }

                        .td-img {
                            width: 11.13%
                        }

                        .td-nome {
                            width: 30.905%;
                            font-weight: 500;
                            padding-left: 1rem;
                        }

                        /* .td-descricao {
                            width: 20.80%;
                            padding: 0;
                            padding-right: 32px;
                            align-self: center;
                            font-family: Montserrat;
                            font-size: 12px;
                            font-weight: 400;
                            line-height: 1.5;
                            text-align: left;
                            color: #2a0709;
                        }

                        .td-valor {
                            width: 11.95%;
                            font-weight: 600;
                        } */

                        .td-switch {
                            width: 30.90%;

                            div {
                                display: flex;
                                flex-direction: row;
                                justify-content: space-between;

                                .more-button {
                                    cursor: pointer;
                                    height: 32px;
                                    width: 32px;
                                    outline: none;
                                    border: none;
                                    border-radius: 32px;
                                    background-color: transparent;
                                    justify-content: center;
                                    align-items: center;
                                    font-family: Montserrat;
                                    font-size: 16px;
                                    font-weight: 600;
                                    transition: 0.2s;
                                    padding-top: 5px;
                                    margin-right: 32px;

                                    .icon {
                                        padding: 0 1rem;
                                        color: #a49b9b;
                                        width: 22px;
                                        height: 22px;
                                        align-self: center;
                                    }

                                    /* :hover {
                                        color: #9c1a1f
                                    } */
                                    :active {
                                        background-color: #dedede
                                    }
                                    
                                    /* @media(max-width: 360px) {
                                        width: 100%;
                                    } */
                                } 
                            }
                        }

                        tbody {
                            cursor: default
                        }

                        th {
                            font-weight: normal;
                            padding: 34px 0;
                            padding-right: -32px;
                            border: none;
                            border-bottom: 2px solid #f3f3f3;
                        }

                        thead {
                            color: #a49b9b;
                        }
                }

    .modos {
            display: flex;
            padding: 40px 0;
            align-items: center;
            padding-left: 2rem;

            @media (max-width: 360px) {
                padding-left: 1rem;
            }

            h3 {
                font-size: 1rem;
                font-family: Montserrat;
                margin: 0;
                font-weight: 500;
                padding-left: 8px;
            }

            .card {
                cursor: pointer;
                display: flex;
                justify-content: center;
                align-items: center;
            }

            .lista {
                cursor: pointer;
                padding-left: 2rem;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

    hr {
        display: block; 
        height: 1px;
        border: 0; 
        border-top: 2px solid #f3f3f3;
        margin: 1em 0; 
        padding: 0;
    }

    .botao-div {
        display: flex;
        padding: 2rem;
        padding-top: 0.5rem;

        @media (max-width: 691px) {
            padding: 0.5rem 1rem 2rem 1rem;
        }
        .salvar {
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #c32027;
            outline: none;
            border: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #fff;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;
            :hover {
                background-color: #9c1a1f
            }
            :active {
                background-color: #d7232c
            }
            @media(max-width: 360px) {
                width: 100%;
            }
        }

        .salvar-branco {
            /* margin-bottom: -56px;  */
            cursor: pointer;
            height: 40px;
            width: 160px;
            background-color: #fff;
            border: 1px solid #c32027;
            outline: none;
            border-radius: 20px;
            justify-content: center;
            align-items: center;
            color: #c32027;
            font-family: Montserrat;
            font-size: 11px;
            font-weight: 600;
            transition: 0.2s;

            :hover {
                background-color: #faf8f8
            }

            :active {
                background-color: #dedede
            }
            @media(max-width: 360px) {
                width: 100%;
            }
        }
    }

        .top-bar {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            z-index: 10;
            background-color: #fff;
            padding: 2rem;
            padding-top: 2.5rem;
            padding-bottom: 2.5rem;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            border-bottom: 1.5px solid #e7e7e7;

            @media(max-width: 691px) {
                padding: 1rem;
                padding-top: 2.5rem;
                padding-bottom: 2rem;
            }

            .textos {
                width: 82%;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                @media(max-width: 691px) {
                    width: 100%;
                }

                .section {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;
                    
                    span {
                        font-family: Montserrat;
                        font-size: 1rem;
                        line-height: 1;
                        color: #2a0709;
                        font-weight: 600;
                        text-align: center;

                        @media(max-width: 691px) {
                            font-size: 0.75rem;
                            text-align: left;
                            line-height: 1.25
                        }
                    }

                    .bola {
                        margin-right: 1rem;
                        width: 1.5rem !important;
                        height: 1.5rem;
                        border-radius: 1.5rem;
                        background-color: #d7232c;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        @media(max-width: 691px) {
                            margin-right: 0.5rem;
                            margin-left: 0.5rem;
                            width: 2rem !important;
                        }

                        span {
                            color: #fff;
                            font-weight: 700;
                            font-size: 0.75rem;
                        }
                    }
                }

                .section-disabled {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;

                    span {
                        font-family: Montserrat;
                        font-size: 1rem;
                        line-height: 1;
                        color: #c0b7b8;
                        font-weight: 400;
                        text-align: center;

                        @media(max-width: 691px) {
                            font-size: 0.75rem;
                            text-align: left;
                            line-height: 1.25
                        }
                    }

                    .bola {
                        margin-right: 1rem;
                        width: 1.5rem;
                        height: 1.5rem;
                        border-radius: 1.5rem;
                        background-color: #c0b7b8;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        @media(max-width: 691px) {
                            margin-right: 0.5rem;
                            width: 2rem;
                        }

                        span {
                            color: #fff;
                            font-weight: 700;
                            font-size: 0.75rem;
                        }
                    }
                }

                .section-filled {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: center;

                    span {
                        font-family: Montserrat;
                        font-size: 1rem;
                        line-height: 1;
                        color: #c0b7b8;
                        font-weight: 400;
                        text-align: center;

                        @media(max-width: 691px) {
                            font-size: 0.75rem;
                            text-align: left;
                            line-height: 1.25
                        }
                    }

                    .bola {
                        margin-right: 1rem;
                        width: 1.5rem;
                        height: 1.5rem;
                        border-radius: 1.5rem;
                        background-color: #52dc75;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        @media(max-width: 691px) {
                            margin-right: 0.5rem;
                            width: 2rem;
                        }

                        span {
                            color: #fff;
                            font-weight: 700;
                            font-size: 0.75rem;
                        }
                    }
                }
            }

        }

        .bottom-bar {
            position: -webkit-sticky;
            position: sticky;
            bottom: 0;
            z-index: 10;
            background-color: #fff;
            border-top: 1.5px solid #e7e7e7;

            .buttons {
                padding-left: 2rem;
                padding-right: 8rem;
                padding-top: 2.5rem;
                padding-bottom: 2.5rem;
                display: flex;
                flex-direction: row;
                justify-content: space-between;

                @media (max-width: 691px) {
                    padding: 1.5rem 1rem
                }

                button {
                    transition: 0.2s;
                    cursor: pointer;
                    height: 2.5rem;
                    width: 10rem;
                    outline: none;
                    border: none;
                    background-color: transparent;
                    border-radius: 20px;
                    justify-content: center;
                    align-items: center;
                    color: #c0b7b8;
                    font-family: Montserrat;
                    font-size: 11px;
                    font-weight: 600;
                    display: flex;
                    text-align: center;

                    .icon {
                        font-size: 1rem;
                        padding-right: 0.5rem
                    }

                    :hover {
                        background-color: #faf8f8;
                    }

                    /* @media(max-width: 600px) {
                        width: 100%;
                        margin-right: 16px;
                    } */
                }

                .next {
                    background-color: #c22027;
                    color: #fff;

                    :hover {
                        background-color: #9d1a1f;
                    }

                    :active {
                        background-color: #d7232b;
                    }
                }
            }
        }

        h4 {
            margin: 0;
            font-family: Montserrat;
            font-size: 16px;
            font-weight: 700;
            font-stretch: normal;
            font-style: normal;
            line-height: 1;
            letter-spacing: normal;
            text-align: left;
            color: #000000;

            @media(max-width: 360px) {
            }
        }

    .imagem {
        padding: 2rem;

        @media(max-width: 360px) {
            padding: 1rem;
        }

        .foto {
            padding-top: 2.5rem;

            .preview {
                transition: 0.2s;
                cursor: pointer;
                width: 11.5rem;
                height: 9.5rem;
                border: 1px solid #dedede;
                border-radius: 8px;
                display:flex;
                align-items: center;
                justify-content: center;
                position: relative;

                img {
                    transition: 0.2s;
                    width: 11.5rem;
                    height: 9.5rem;
                    border-radius: 8px;
                    overflow: hidden;
                    object-fit: cover;
                }

                .imagem {
                    width: 11.5rem;
                    height: 9.5rem;
                    transition: 0.2s;
                    opacity: 1;
                }

                .lixeira {
                    opacity: 0;
                    transition: 0.2s;
                    z-index: 9;
                    position: absolute;
                    align-self: center;
                    width: 2.5rem;
                    height: 2.5rem;
                }

                :hover {
                        .imagem {
                            opacity: 0.5;
                        }
                        .lixeira {
                            opacity: 1;
                        }
                    }
                }
            }
        }
    }

    .informacoes {
        padding: 2rem;

        @media (max-width: 360px) {
            padding: 1rem;
            padding-top: 3rem;

            h4 {
                padding-bottom: 1rem
            }
        }
    }

    .adicionais {
        padding: 2rem;

        @media (max-width: 360px) {
            padding: 1rem;
            padding-top: 2rem;
        }

        h5 {
            margin: 0;
            padding: 0;
            padding-top: 1.5rem;
            font-size: 1rem;
            font-weight: normal;
            font-family: Montserrat;
            color: #a49b9b;
            line-height: 2;
            max-width: 416px;
        }

        .options  {
                width: 100%;
                display: flex;
                flex-wrap: wrap;
                justify-content: flex-start;
                align-items: center;
                flex-direction: row;
                padding-top: 2.5rem;

                @media(max-width: 360px) {
                    padding-top: 1.5rem;
                }

                .option {
                    cursor: pointer;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    border: 2.5px solid #2a0709;
                    border-radius: 100px;
                    padding: 12px 32px;

                    @media(max-width: 360px) {
                        padding: 6px 14px
                    }

                    span {
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 700;
                        color: #2a0709;

                        @media(max-width: 360px) {
                            font-size: 13px;
                        }
                    }
                }

                .option-selected {
                    cursor: pointer;
                    margin-right: 16px;
                    margin-bottom: 16px;
                    background-color: #2a0709;
                    border: 2.5px solid #2a0709;
                    border-radius: 100px;
                    padding: 12px 32px;

                    @media(max-width: 360px) {
                        padding: 6px 14px
                    }

                    span {
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 700;
                        color: #fff;

                        @media(max-width: 360px) {
                            font-size: 13px;
                        }
                    }
                }
            }
    }

    .grupo-adicionais {
        /* padding: 2rem; */

        h4 {
            padding-left: 16px;
            margin-left: 16px;

            @media (max-width: 690px) {
                padding-left: 1rem;
                margin-left: 0px;
            }
        }

        h5 {
            margin: 0;
            padding: 0;
            padding: 1.5rem 0 1rem 2rem;
            font-size: 1rem;
            font-weight: normal;
            font-family: Montserrat;
            color: #a49b9b;
            line-height: 2;
            max-width: 416px;

            @media (max-width: 690px) {
                padding: 1.5rem 0 1rem 1rem;
            }
        }

        .itens {
            padding: 1.875rem 2rem 2rem; 
            display: flex;
            width: 90%;
            flex-direction: row;
            flex-wrap: wrap;
            flex: 0 0 33%;
            align-items:center;
            justify-content: left;

            @media (max-width: 360px) {
                -webkit-overflow-scrolling: touch;
                overflow-x: auto;
                width: auto;
                padding: 1.875rem 1rem 2rem;
                flex-wrap: nowrap;

                &::-webkit-scrollbar {
                    display: none;
                }
            }
            .item-add {
                background-color: #faf8f9;
                cursor: pointer;
                position: relative;
                align-items: left;
                justify-content: center;
                margin-top: 1rem;
                width: 204px;
                height: 144px;
                display: flex;
                flex-direction: column;
                border-radius: 0.5rem;
                border: 2px dashed #a09c9d;

                @media (max-width: 360px) {
                    flex: 0 0 auto;
                }

                span {
                    padding-left: 1.75rem;
                    padding-top: 0.75rem;
                    font-family: Montserrat;
                    color: #220a0c;
                    font-size: 1rem;
                    font-weight: 400;

                    :first-child {
                        padding-top: 0;
                    }

                    p {
                        margin: 0;
                        padding: 0;
                    }
                }

                .title {
                    color: #aeaba9;
                    font-size: 0.75rem;
                }

                button {
                    cursor: pointer;
                    position: absolute;
                    top: 1.25rem;
                    right: 1.25rem;
                    border: 0;
                    outline: 0;
                    background-color: transparent;
                        .i-close {
                        font-size: 1.25rem
                    }
                }
            }

            .item-disabled {
                background-color: #faf8f9;
                cursor: not-allowed;
                position: relative;
                margin-right: 1rem;
                align-items: left;
                justify-content: center;
                margin-top: 1rem;
                width: 204px;
                height: 144px;
                display: flex;
                flex-direction: column;
                border-radius: 0.5rem;
                border: 1px solid #dedede;

                span {
                    padding-left: 1.75rem;
                    padding-top: 0.75rem;
                    font-family: Montserrat;
                    color: #220a0c;
                    font-size: 1rem;
                    font-weight: 400;
                    max-height: 1.4em;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 1;
                    -moz-box-orient: vertical;
                    width: 150px;

                    :first-child {
                        padding-top: 0;
                    }
                }

                .title {
                    color: #aeaba9;
                    font-size: 0.75rem;
                }

                button {
                    cursor: not-allowed;
                    position: absolute;
                    top: 1.25rem;
                    right: 1.25rem;
                    border: 0;
                    outline: 0;
                    background-color: transparent;
                        .i-close {
                        font-size: 1.25rem
                    }
                }
            }

            .item {
                cursor: pointer;
                position: relative;
                margin-right: 1rem;
                align-items: left;
                justify-content: center;
                margin-top: 1rem;
                width: 204px;
                height: 144px;
                display: flex;
                flex-direction: column;
                border-radius: 0.5rem;
                border: 1px solid #dedede;

                @media (max-width: 360px) {
                    flex: 0 0 auto;
                }

                span {
                    padding-left: 1.75rem;
                    padding-top: 0.75rem;
                    font-family: Montserrat;
                    color: #220a0c;
                    font-size: 1rem;
                    font-weight: 400;
                    overflow: hidden;
                    white-space:nowrap;
                    text-overflow:ellipsis;
                    width:75%;
                    display:inline-block;

                    :first-child {
                        padding-top: 20px;
                    }
                }

                .title {
                    color: #aeaba9;
                    font-size: 0.75rem;
                }

                button {
                    cursor: pointer;
                    position: absolute;
                    top: 1.25rem;
                    right: 1.25rem;
                    border: 0;
                    outline: 0;
                    background-color: transparent;
                        .i-close {
                        font-size: 1.25rem
                    }
                }
            }
        }
    }

    .situacao {
        padding: 2rem;

        @media (max-width: 360px) {
            padding: 1rem
        }

        .switch {
            cursor: pointer;
            display: flex;
            flex-direction: row;
            align-items: center;
            padding-top: 40px;
            h4 {
                margin: 0;
                margin-left: 16px;
                padding: 0;
                font-family: Montserrat;
                font-size: 16px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1;
                letter-spacing: normal;
                text-align: left;
                color: #2a0709
            }
        }
    }

    .editar {
        padding: 2rem;

        @media (max-width: 360px) {
            padding: 1rem
        }

        h5 {
            margin: 0;
            padding: 0;
            padding-top: 2rem;
            font-size: 1rem;
            font-weight: normal;
            font-family: Montserrat;
            color: #a49b9b;
            line-height: 2;
            max-width: 416px;
        }

        .button-div {
            display: flex;
            padding-top: 2.5rem;
            padding-bottom: 2rem;
                
            .salvar {
                cursor: pointer;
                height: 40px;
                width: 160px;
                background-color: #c32027;
                outline: none;
                border: none;
                border-radius: 20px;
                justify-content: center;
                align-items: center;
                color: #fff;
                font-family: Montserrat;
                font-size: 11px;
                font-weight: 600;
                transition: 0.2s;

                :hover {
                    background-color: #9c1a1f
                }

                :active {
                    background-color: #d7232c
                }
                @media(max-width: 360px) {
                    width: 100%;
                }
            }

            .salvar-branco {
                /* margin-bottom: -56px;  */
                cursor: pointer;
                height: 40px;
                width: 160px;
                background-color: #fff;
                border: 1px solid #c32027;
                outline: none;
                border-radius: 20px;
                justify-content: center;
                align-items: center;
                color: #c32027;
                font-family: Montserrat;
                font-size: 11px;
                font-weight: 600;
                transition: 0.2s;

                :hover {
                    background-color: #faf8f8
                }

                :active {
                    background-color: #dedede
                }
                @media(max-width: 360px) {
                    width: 100%;
                }
            }
        }
    }

    .tamanho {
        padding: 2rem;

        @media (max-width: 691px) {
            padding: 1rem;
            padding-top: 2rem;
            padding-left: 32px;
        }

        .tamanhos {
            display: flex;
            flex-direction: row;
            width: 95%;
            flex-wrap: wrap;
            flex: 0 0 10%;
            align-items:center;
            justify-content: space-between;

            @media (max-width: 691px) {
                width: 100%;
            }

            .option-selected {
                padding: 2.5rem;
                padding-bottom: 0;
                padding-right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                flex-direction: column;

                :first-child {
                    padding-left: 0;
                }

                :last-child {
                    padding-right: 2.5rem;
                    padding-left: 2.5rem;

                    @media (max-width: 691px) {
                        padding-left: 0;
                        padding-right: 1.5rem;
                    }
                }

                div {
                    width: 4.5rem;
                    height: 4.5rem;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 2px solid #c32027;
                    background-color: #faf8f8;
                    border-radius: 8px;
                }
                img {
                    width: 1.5rem;
                    height: 1.5rem;
                }
                span {
                    padding-top: 1rem;
                    font-family: Montserrat;
                    font-size: 1rem;
                    color: #000;
                    font-weight: 550;
                }
                :nth-child(3) {
                    img {
                        width: 2rem;
                        height: 1.3125rem;
                    }
                }
                :nth-child(4) {
                    padding-left: 2.5rem;
                    @media (max-width: 691px) {
                        padding-left: 1.5rem
                    }
                    img {
                        width: 2.875rem;
                        height: 1.3125rem;
                    }
                }
            }

            .option {
                padding: 2.5rem;
                padding-bottom: 0;
                padding-right: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                flex-direction: column;

                :first-child {
                    padding-left: 0;
                }

                :last-child {
                    padding-right: 2.5rem;
                    padding-left: 2.5rem;

                    @media (max-width: 691px) {
                        padding-left: 0;
                        padding-right: 1.5rem;
                    }
                }

                div {
                    width: 4.5rem;
                    height: 4.5rem;
                    cursor: pointer;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border: 1px solid #dedede;
                    border-radius: 8px;

                    :hover {
                        transition: 0.2s;
                        background-color: #faf8f8;
                    }
                }
                img {
                    width: 1.5rem;
                    height: 1.5rem;
                }
                span {
                    padding-top: 1rem;
                    font-family: Montserrat;
                    font-size: 1rem;
                    color: #000;
                    font-weight: 300;
                }
                :nth-child(3) {
                    img {
                        width: 2rem;
                        height: 1.3125rem;
                    }
                }
                :nth-child(4) {
                    padding-left: 2.5rem;
                    @media (max-width: 691px) {
                        padding-left: 1.5rem
                    }
                    img {
                        width: 2.875rem;
                        height: 1.3125rem;
                    }
                }
            }
        }
    }

    .ingredientes {
        padding: 2rem;

        @media (max-width: 360px) {
            padding: 1rem;
            padding-top: 2rem;

            h4 {
                padding-bottom: 1rem
            }

            span {
                padding-bottom: 1rem
            }
        }

        .title {
            max-width: 41.4375rem;
            display: flex;
            align-items: center;
            justify-content: space-between;

            span {
                font-family: Montserrat;
                font-size: 14px;
                font-weight: 400;
                color: #000;
            }
        }
    }

    .preco {
        padding: 2rem;

        @media (max-width: 360px) {
            padding: 1rem;
            padding-top: 2rem;
            padding-bottom: 3rem;

            h4 {
                padding-bottom: 1rem
            }
        }
    }

    .close {
        position: absolute;
        right: 32px;
        top: 32px;

        @media(max-width: 600px) {
                right: 1rem;
                top: 2.5rem;
            }
        
        button {
            background-color: transparent;
            outline: none;
            cursor: pointer;
            border: none;
            align-self: center;
            box-sizing: border-box;

            .i-close {
                vertical-align: middle;
                align-self: center;
                font-size: 36px;
                top: 10px;
                bottom: 10px;
                left: 10px;
                right: 10px;
                color: #c0b7b8 !important;

                @media(max-width: 600px) {
                    font-size: 26px;
                    top: 16px;
                    bottom: 16px;
                    left: 16px;
                    right: 16px;
                }
            }
        }
    }

    .header {
        display: flex;
        flex-direction: column;
        max-width: 560px;
        padding: 2rem;
        padding-top: 3rem;

        // @media (max-width: 420px) {
        //     padding-top: 40px;
        //     padding-left: 16px;
        //     max-width: 291px;
        // }

        @media (max-width: 691px) {
            padding-left: 32px;
            max-width: 400px;
        }

            img {
                width: 32px;
                height: 32px;
                margin: 0px;
                padding: 0px;
                object-fit: contain;
            }

            h1 {
                font-family: Montserrat;
                font-size: 2rem;
                margin: 0;
                padding: 0;
                margin-top: 1.5rem;
                font-weight: 700;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                text-align: left;
                color: #000000;

                @media(max-width: 420px) {
                        font-size: 1.5rem;
                    }
            }

            h5 {
                margin: 0;
                padding: 0;
                padding-top: 1.5rem;
                font-size: 1rem;
                font-weight: normal;
                font-family: Montserrat;
                color: #a49b9b;
                line-height: 2;
                max-width: 416px;
            }
    }

        .entrada-saida {
            padding-left: 8px;
            display: flex; 
            flex-direction: row;

            @media (max-width: 600px) {
                flex-direction: column;
                padding-left: 16px;
                padding-right: 16px;
            }

            .horario {
                margin-left: 24px;
                position: relative;
                display: flex; 
                flex-direction: column;
                list-style: none;

                @media (max-width: 600px) {
                    margin-left: 0;
                    width: 100%;
                }

                .turno-aberto{
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                    justify-content: space-between;
                    cursor: pointer;
                    width: 204px;
                    height: 88px;
                    border: 1.5px solid #ececec;
                    background-color: #fff;
                    border-radius: 10px;

                    @media (max-width: 600px) {
                        width: 100%;
                        margin-right: 32px;
                        margin-bottom: 16px;
                    }

                    .left {
                        padding-left: 24px;
                    }

                    .chevron {
                        padding-right: 24px;
                    }

                    h4 {
                        margin: 0;
                        padding: 0;
                        font-family: Montserrat;
                        font-size: 16px;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #2a0709;
                    }
                    h5 {
                        margin: 0;
                        margin-bottom: 12px;
                        padding: 0;
                        font-family: Montserrat;
                        font-size: 12px;
                        font-weight: 600;
                        font-stretch: normal;
                        font-style: normal;
                        line-height: 1;
                        letter-spacing: normal;
                        text-align: left;
                        color: #a49a9b;
                    }
                }
            }
        }

        .calendario {
            padding-left: 32px;
        }

        .label-resto {
            position: absolute;
            font-family: Montserrat;
            font-size: 14px;
            width: 260px;
            color: #000000;
            @media(max-width: 360px) {
                margin-top: 4px;
            }
        }

        .div-invalido {
            width: 95%;
            max-width: 540px;
            overflow: hidden;
            box-sizing: border-box;
            margin-top: 1rem;

            .texto-invalido {
                font-family: Montserrat;
                font-size: 12px;
                font-weight: 600;
                font-stretch: normal;
                font-style: normal;
                line-height: 1.5;
                letter-spacing: normal;
                color: #c42027;
                float: left;
                cursor: default;
            }
        }

        .cartao {
                display: flex; 
                position: relative;
                flex-direction: row;
                align-items:center;
                height: 16px;
                margin-top: 40px;
                margin-left: 32px;
                margin-right: 16px;
                list-style: none;

                @media(max-width: 360px) {
                    margin-left: 16px;
                    margin-top: 48px;
                }

                .main { 
                    display: block; 
                    position: relative; 
                    cursor: pointer;
                } 
          
                /* Hide the default checkbox */ 
                input[type=checkbox] { 
                    visibility: hidden; 
                    margin-right: 16px;
                } 
                
                /* Creating a custom checkbox 
                based on demand */ 
                .check { 
                    position: absolute; 
                    top: 0; 
                    left: 0;
                    height: 16px; 
                    width: 16px; 
                    border-radius: 3px;
                    background-color: #fff; 
                    border: 1px solid #a49a9b;

                    @media(max-width: 360px) {
                        top: 4px;
                    }
                } 

                .check-app { 
                    position: absolute; 
                    top: 0; 
                    left: 0;
                    height: 16px; 
                    width: 16px; 
                    border-radius: 3px;
                    background-color: #fff; 
                    border: 1px solid #a49a9b;

                    @media(max-width: 360px) {
                        top: 4px;
                    }
                } 
                
                /* Specify the background color to be 
                shown when hovering over checkbox */ 
                .main:hover input ~ .check { 
                    background-color: #ebedee; 
                } 
                
                /* Specify the background color to be 
                shown when checkbox is active */ 
                .main input:active ~ .check { 
                    background-color: #c42027; 
                    border: 1px solid #c42027
                } 
                
                /* Specify the background color to be 
                shown when checkbox is checked */ 
                .main input:checked ~ .check { 
                    background-color: #d7232c; 
                    border: 1px solid #d7232c
                } 

                .main input:checked ~ .check-app { 
                    background-color: #dedede; 
                } 
                
                /* Checkmark to be shown in checkbox */ 
                /* It is not be shown when not checked */ 
                .check:after { 
                    content: ""; 
                    position: absolute; 
                    display: none; 
                } 

                .check-app:after { 
                    content: ""; 
                    position: absolute; 
                    display: none; 
                } 
                
                /* Display checkmark when checked */ 
                .main input:checked ~ .check:after { 
                    display: block; 
                } 

                .main input:checked ~ .check-app:after { 
                    display: block; 
                } 
                
                /* Styling the checkmark using webkit */ 
                /* Rotated the rectangle by 45 degree and  
                showing only two border to make it look 
                like a tickmark */ 
                .main .check:after { 
                    left: 5px; 
                    bottom: 5px; 
                    width: 4px; 
                    height: 6px; 
                    border: solid white; 
                    border-radius: 1px;
                    border-width: 0 2px 2px 0; 
                    -webkit-transform: rotate(45deg); 
                    -ms-transform: rotate(45deg); 
                    transform: rotate(45deg); 
                } 

                .main .check-app:after { 
                    left: 5px; 
                    bottom: 5px; 
                    width: 4px; 
                    height: 6px; 
                    border: solid #a49a9b; 
                    border-radius: 1px;
                    border-width: 0 2px 2px 0; 
                    -webkit-transform: rotate(45deg); 
                    -ms-transform: rotate(45deg); 
                    transform: rotate(45deg); 
                } 
            }

        .div-input {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-top: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 600px) {
            width: 100%;
            height: 64px;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input-disabled {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-top: 40px;
        padding: 0;
        box-sizing: border-box;
        background-color: #faf8f9;

        @media(max-width: 600px) {
            width: 100%;
            height: 64px;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input-disabled-box {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 152px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-top: 40px;
        padding: 0;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 8px;
        box-sizing: border-box;
        background-color: #faf8f9;

        @media(max-width: 600px) {
            width: 100%;
            height: 7.25rem;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input-box {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 152px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid lightgray;
        margin-top: 40px;
        padding: 0;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 8px;
        box-sizing: border-box;

        @media(max-width: 691px) {
            width: 100%;
            // height: 7.25rem;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input-focado {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        margin-top: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 691px) {
            width: 100%;
            // height: 64px;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input-focado-box {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 152px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #1c0506;
        margin-top: 40px;
        padding: 0;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 8px;
        box-sizing: border-box;

        @media(max-width: 691px) {
            width: 100%;
            // height: 7.25rem;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input-error {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 78px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-top: 40px;
        padding: 0;
        box-sizing: border-box;

        @media(max-width: 600px) {
            width: 100%;
            height: 64px;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input-error-box {
        position: relative;
        width: 90%;
        max-width: 663px;
        height: 152px;
        overflow: hidden;
        border-radius: 10px;
        border: 0.25px solid #c32027;
        margin-top: 40px;
        padding: 0;
        padding-right: 20px;
        padding-left: 20px;
        padding-top: 8px;
        box-sizing: border-box;

        @media(max-width: 600px) {
            width: 100%;
            height: 7.25rem;
            align-self: center;
            margin-top: 1.5rem;
            margin-left: 0;
        }
    }

    .div-input input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-disabled input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-disabled-box textarea {
        padding: 0;
        resize: none;
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        color: #1c0506;
        padding-top: 2rem;
        margin-bottom: 40px;
        border: none;
        outline: none;
        background: #faf8f9;
        

        :disabled {
            cursor: not-allowed;
            background: #faf8f9;
            width: 100%;
        }
    }

    .div-input-box textarea {
        padding: 0;
        resize: none;
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        color: #1c0506;
        padding-top: 2rem;
        margin-bottom: 40px;
        border: none;
        outline: none;

        @media (max-width: 360px) {
            padding-top: 1.5rem;
        }
    }

    .div-input-focado input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #1c0506;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-focado-box textarea {
        padding: 0;
        resize: none;
        font-family: Montserrat;
        font-size: 16px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        color: #1c0506;
        padding-top: 2rem;
        margin-bottom: 40px;
        border: none;
        outline: none;

        @media (max-width: 360px) {
            padding-top: 1.5rem;
        }
    }

    .div-input-error input {
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 80%;
        height: 100%;
        color: #c42027;
        padding-top: 13px;
        border: none;
        outline: none;
        padding-left: 20px;

        @media(max-width: 360px) {
            padding-top: 8px;
        }
    }

    .div-input-error-box textarea {
        padding: 0;
        resize: none;
        font-family: Montserrat;        
        font-size: 16px;
        font-weight: 500;
        width: 100%;
        height: 100%;
        color: #c42027;
        padding-top: 2rem;
        margin-bottom: 40px;
        border: none;
        outline: none;

        @media (max-width: 360px) {
            padding-top: 1.5rem;
        }
    }

    .div-input label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-disabled label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-disabled-box label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 94px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media (max-width: 360px) {
            bottom: 22px
        }
    }

    .div-input-box label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 94px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media (max-width: 360px) {
            bottom: 22px
        }
    }

    .div-input-focado label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-focado-box label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 94px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media (max-width: 360px) {
            bottom: 22px
        }
    }

    .div-input-error label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 20px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media(max-width: 360px) {
            bottom: 12px;
        }
    }

    .div-input-error-box label {
        font-family: Montserrat;
        font-weight: 600;
        color: lightgray;
        position: absolute;
        bottom: 94px;
        left: 20px;
        width: 100%;
        height: 100%;
        pointer-events: none;

        @media (max-width: 360px) {
            bottom: 22px
        }
    }

    .div-input label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-disabled label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-disabled-box label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-box label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;        
    }

    .div-input-focado label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-focado-box label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .div-input-error-box label::after {
        content: "";
        position: absolute;
        left: 0px;
        bottom: 10px;
        height: 100%;
        width: 100%;
        transform: translateX(-100%);
        transition: transform 0.3s ease;
    }

    .content-name {
        position: absolute;
        bottom: 8px;
        left: 0px;
        transition: all 0.3s ease;
    }

    .div-input input:focus + .label-name .content-name,
    .div-input input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-disabled input:focus + .label-name .content-name,
    .div-input-disabled input:valid + .label-name .content-name,
    .div-input-disabled input:disabled + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-disabled-box textarea:focus + .label-name .content-name,
    .div-input-disabled-box textarea:valid + .label-name .content-name,
    .div-input-disabled-box textarea:disabled + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input::after {
            border: none;
        }
    }

    .div-input-disabled input:focus + .label-name::after,
    .div-input-disabled input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-disabled-box textarea:focus + .label-name::after,
    .div-input-disabled-box textarea:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-disabled button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-disabled-box button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-box textarea:focus + .label-name .content-name,
    .div-input-box textarea:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-box::after {
            border: none;
        }
    }

    .div-input-focado input:focus + .label-name .content-name,
    .div-input-focado input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado::after {
            border: none;
        }
    }

    .div-input-focado-box textarea:focus + .label-name .content-name,
    .div-input-focado-box textarea:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-focado-box::after {
            border: none;
        }
    }

    .div-input-error input:focus + .label-name .content-name,
    .div-input-error input:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error::after {
            border: none;
        }
    }

    .div-input-error-box textarea:focus + .label-name .content-name,
    .div-input-error-box textarea:valid + .label-name .content-name {
        transform: translateY(-150%);
        bottom: 0px;
        font-size: 12px;

        .div-input-error-box::after {
            border: none;
        }
    }

    .div-input input:focus + .label-name::after,
    .div-input input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-box textarea:focus + .label-name::after,
    .div-input-box textarea:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado input:focus + .label-name::after,
    .div-input-focado input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-focado-box textarea:focus + .label-name::after,
    .div-input-focado-box textarea:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error input:focus + .label-name::after,
    .div-input-error input:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input-error-box textarea:focus + .label-name::after,
    .div-input-error-box textarea:valid + .label-name::after {
        transform: translateX(0%);
    }

    .div-input button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-focado button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

    .div-input-error button {
        position: absolute;
        right: 15px;
        top: 20px;
        background-color: transparent;
        outline: none;
        cursor: pointer;
        border: none;
        align-self: center;
        box-sizing: border-box;
        font-size: 28px;

        :hover {
            opacity: 0.6;
        }
        .i {
            vertical-align: middle;
        }

        @media(max-width: 590px) {
            font-size: 22px;
            top: 25px;
        }
        @media(max-width: 360px) {
            font-size: 18px;
            top: 20px
        }
    }

        .botao {
            display: flex;
            padding-left: 32px;
            padding-top: 56px;
            padding-bottom: 80px;

            @media(max-width: 600px) {
                    padding-top: 40px;
                    padding-left: 16px;
                    padding-bottom: 40px;
                }

            .salvar {
                cursor: pointer;
                height: 40px;
                width: 160px;
                background-color: #c32027;
                outline: none;
                border: none;
                border-radius: 20px;
                justify-content: center;
                align-items: center;
                color: #fff;
                font-family: Montserrat;
                font-size: 11px;
                font-weight: 600;
                transition: 0.2s;

                :hover {
                    background-color: #9c1a1f
                }

                :active {
                    background-color: #d7232c
                }

                @media(max-width: 600px) {
                    width: 100%;
                    margin-right: 16px;
                }
            }
        }

        .yellow-box-product{
        //    position: relative;
            width: 90%;
            max-width: 663px;
            // overflow: hidden;
            // margin-top: 40px;
            box-sizing: border-box;
    
    
    
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            padding: 24px;
            background: #FFF9E9;
            border-radius: 8px;
            margin-top: 12px;
    
            @media(max-width: 690px){
                width: 100%;
            }
    
            span {
                text-decoration: underline;
                cursor: pointer;
            }
    
            text{
                font-family: 'Montserrat';
                font-style: normal;
                font-weight: 600;
                font-size: 12px;
                line-height: 20px;
                color: #2D2D2D;
            }
        }
        
`